import ViewerWrapper from './ViewerWrapper';

export default ViewerWrapper;